import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';


export class CustomerNeed{
  constructor(){}

  public customerId : number;
  public customerNeed : string;
}

@Injectable({
  providedIn: 'root'
})

export class CustomerNeedService {
  
  
  constructor(private httpClient:HttpClient) { }

  public getAllCustomerNeeds() {
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.get<CustomerNeed[]>('/api/v1/customerNeed/',{headers}).pipe(catchError(this.errorHandler));
  }

  
  updateCustomerNeed(bean: any): Observable<any> {
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.put<any>('/api/v1/customerNeed/' , bean , {headers}).pipe(catchError(this.errorHandler));
  }
  
  public createCustomerNeed(obj : any) : Observable<any>{
    //console.log(obj);
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.post<any>('/api/v1/customerNeed/' , obj , {headers}).pipe(catchError(this.errorHandler));
  }

  deleteCustomerNeed(Id: number){
    return this.httpClient.delete('api/v1/customerNeed/' + Id);
  }

  errorHandler(error: HttpErrorResponse){
    console.log(error.message);
    return throwError(error.message || 'Server Error');

  }
}
